<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="仓库期初"
      edit-title
      id-key="BeginningId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="仓库名称" prop="WarehouseId">
          <warehouse-select v-model="data.WarehouseId" @change="changeWare" />
        </el-form-item>
        <el-form-item label="商品名称" prop="GoodsId">
          <select-input
            placeholder="请选择商品"
            :label="data.GoodsName"
            v-model="data.GoodsId"
            @click="addGoods"
          />
        </el-form-item>
        <el-form-item label="数量" prop="Quantity1" v-if="data.GoodsId">
          <el-input v-model="data.Quantity1" placeholder="数量" @blur="onBlur(data,'Quantity1')" @focus="onFocus(data,'Quantity1')">
            <template slot="append">{{data.Unit1Name}}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="成本主单价" prop="UnitPrice">
          <el-input v-model="data.UnitPrice" placeholder="成本主单价" @blur="onBlur(data,'UnitPrice')" @focus="onFocus(data,'UnitPrice')"/>
        </el-form-item>
        <el-form-item label="成本金额" prop="Amount">
          <el-input v-model="data.Amount" placeholder="成本金额" @blur="onBlur(data,'Amount')" @focus="onFocus(data,'Amount')"></el-input>
        </el-form-item>
      </template>
    </common-dialog>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import goodsDialog from "@/components/sales/business/listDialog";
import warehouseSelect from "@/components/basicinfo/basic/warehouse/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    goodsDialog,
    warehouseSelect,
  },
  data() {
    return {
      data: {
        WarehouseId: "",
        BeginningId: 0,
        GoodsId: 0,
        GoodsName: "",
        Quantity1: 0,
        Unit1Id: 0,
        Quantity2: 0,
        Unit2Id: 0,
        UnitPrice: 0,
        Amount: 0,
      },
      api: require("@/api/sy/ware").default,
      wareList: [],
      rules: {
        WarehouseId: [{ required: true, message: "仓库名称不能为空" }],
        GoodsName: [{ required: true, message: "商品名称不能为空" }],
      },
    };
  },
  methods: {
    addGoods(e) {
      if (!this.data.WarehouseId) {
        this.$message.warning("请先选择仓库");
        return;
      }
      this.$refs.goodsDialog.open().then((that) => {
        that.getData({ Status: 1, WarehouseId: this.data.WarehouseId });
      });
    },
    changeWare(e) {
      Object.assign(this.$data, this.$options.data());
      this.data.WarehouseId = e;
    },
    setGoods(e) {
      this.data.GoodsId = e.GoodsId;
      this.data.GoodsName = e.GoodsName;
      this.data.Unit1Id = e.MainUnitId;
      this.data.Unit1Name = e.MainUnitName;
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
       this.data[type] = this.$commonJs.obj.toNumber(this.data[type]);
    },
     onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
  },
};
</script>
<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>